export const normalizeDate = (date: Date): Date => {
  const normalized = new Date(date)
  normalized.setHours(0, 0, 0, 0)
  return normalized
}

export const getNormalizedToday = (): Date => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return normalizeDate(date1).getTime() === normalizeDate(date2).getTime()
}

export const isDateInThePast = (date: Date): boolean => {
  const today = getNormalizedToday()
  const normalizedDate = normalizeDate(date)
  return normalizedDate.getTime() < today.getTime()
}
